import useResources from "./useResources"

function useRender() {
    const { sections } = useResources();

    const renderComponents = (build) => {
        // Verificar que el build tenga componentes válidos
        if (!build || !build.components || !Array.isArray(build.components)) {
            return null;
        }

        return (
            <>
                {build.components.map((component, index) => {
                    // Verificar que el componente existe y tiene category_id válido
                    if (!component || 
                        !component.product_name || 
                        !component.category_id) {
                        return null;
                    }

                    // Buscar la sección correspondiente por category_id
                    // category_id 1 = PROCESADORES (index 1 en sections)
                    // category_id 2 = PLACA MADRE (index 2 en sections)
                    // category_id 3 = TARJETA GRÁFICA (index 3 en sections)
                    // category_id 4 = MEMORIA RAM (index 4 en sections)
                    // category_id 5 = ALMACENAMIENTO (index 5 en sections)
                    // category_id 6 = FUENTES DE PODER (index 6 en sections)
                    const sectionIndex = component.category_id;
                    const section = sections[sectionIndex];

                    // Verificar que la sección existe y tiene icono
                    if (!section || !section.icon) {
                        return null;
                    }

                    // Obtener el nombre de display para la categoría
                    const displayName = getCategoryDisplayName(section.section);

                    return (
                        <div key={`component-${component.category_id}-${index}`} className="row-component-container">
                            <div className="row-component-img">
                                <img 
                                    src={section.icon} 
                                    alt={`${section.section} ICON`} 
                                    width="100%"
                                />
                            </div>
                            <div className="row-component-title">
                                <p>{displayName}</p>
                                <h2>{component.product_name}</h2>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };

    // Función helper para convertir nombres de categorías a nombres de display
    const getCategoryDisplayName = (categoryName) => {
        const categoryMapping = {
            "PROCESADORES": "Procesador",
            "PLACA MADRE": "Placa madre",
            "TARJETA GRÁFICA": "Tarjeta de video",
            "MEMORIA RAM": "Memoria ram",
            "ALMACENAMIENTO": "Almacenamiento",
            "FUENTES DE PODER": "Fuente de poder"
        };

        return categoryMapping[categoryName] || categoryName.toLowerCase();
    };

    return { renderComponents };
}

export default useRender;